import { Button } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React from 'react';

import { Grid } from '@mui/material';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { getTextWithToolTip } from '../../core-utils/helper-utils/riskPatientDetailsHelper';

export const formatEmployerGroupNameForTable = (
  name: string,
  _id: string,
  handleEmployeerGroupCardClick: any,
  isToolTip: boolean = false,
  data: any,
  isCaseClosed?: boolean,
) => {
  return (
    <Grid container direction="row">
      <Grid>
        <Button
          width="100%"
          variant="text"
          justifyContent="left"
          styleProps={{ padding: '6px 0px' }}
          onClick={() =>
            handleEmployeerGroupCardClick({ ...data, isCaseClosed })
          }
          label={
            <Typography
              style={{
                fontSize: '14px',
                lineHeight: '28px',
                color: patientAccessTheme.palette.primary.main,
                fontWeight: 500,
                margin: '0px 0px 0px 0px',
                background: `linear-gradient(to right, ${patientAccessTheme.palette.primary[500]} 50%, rgba(255, 255, 255, 0) 0%)`,
                backgroundPosition: 'bottom',
                backgroundRepeat: 'repeat-x',
                backgroundSize: '6px 1px',
              }}
            >
              {isToolTip
                ? name.length > 16
                  ? getTextWithToolTip(name, 16)
                  : name
                : name}
            </Typography>
          }
        />
      </Grid>
    </Grid>
  );
};

export const roleMap = (role: string) => {
  switch (role) {
    case 'super_admin':
      return 'Super Admin';
    case 'admin':
      return 'Admin';
    case 'user':
      return 'User';

    default:
      return '-';
  }
};
